import { TrialState } from '@/constants/user/userTrialState'

export const isTrialCustomer = (user: User | null | undefined): boolean => {
	if (!user) return false

	const trialState = user.organisation.trialState ?? TrialState.NotInTrial

	return trialState !== TrialState.NotInTrial
}
